export const profile = {
  name: "Yuddhish Chooah",
  firstName: "Yuddhish",
  initials: "YC",
  title: "AI Engineer, Software Developer & Robotics Researcher",
  location: "Darmstadt, Germany",
  email: "yuddhish@gmail.com",
  linkedin: "https://www.linkedin.com/in/yuddhish-chooah",
  github: "https://github.com/yuddhishChooah",
  introduction:
    "I am an AI engineer, software developer, and robotics researcher pursuing an MSc in Artificial Intelligence and Machine Learning at Technische Universität Darmstadt. My work connects computer vision, autonomous robotics, modern web applications, and data systems.",
  tagline: "I build intelligent systems.",
  supportingLine:
    "From computer-vision research and autonomous robots to modern web applications and data-driven software.",
  academicStatus: "MSc AI & ML · TU Darmstadt",
  availability: "Open to research and engineering conversations",
  photoUrl: null as string | null,
  portfolioUrl: "https://yuddhish.com",
  cvRequestUrl: "/?request=cv#contact",
  placeholders: {
    domain: false,
    github: false,
  },
  publish: {
    email: true,
    location: true,
    phone: false,
    photo: false,
  },
  phone: "",
} as const;
